// extracted by mini-css-extract-plugin
module.exports = {"scrollbar-v":"scrollbar-tab_scrollbar-v__6gGsO","scrollbar-v-tabs":"scrollbar-tab_scrollbar-v-tabs__zZ0O1","scroll":"scrollbar-tab_scroll__1wngC"};